import { MapFieldsStep } from '@repo/formevo-configuration/MapFieldsStep'
import { SelectFormStep } from '@repo/formevo-configuration/SelectFormStep'
import { SelectWorktypeStep } from '@repo/formevo-configuration/SelectWorktypeStep'

export default [
  {
    stageLabel: 'Form mapping',
    stageId: 'formevo-form-mapping',
    steps: [
      {
        stepLabel: 'Select worktype',
        stepDescription: 'Does this mapping rule apply to a specific worktype?',
        stepId: 'select-worktype',
        skippable: false,
        component: SelectWorktypeStep,
        uniqueId: 'formevo-select-worktype'
      },
      {
        stepLabel: 'Select form',
        stepDescription: 'Select the FormEvo form to map',
        stepId: 'select-form',
        skippable: false,
        component: SelectFormStep,
        uniqueId: 'formevo-select-form'
      },
      {
        stepLabel: 'Map fields',
        stepDescription: 'Map FormEvo fields to Osprey data',
        stepId: 'map-fields',
        skippable: false,
        component: MapFieldsStep,
        uniqueId: 'formevo-map-fields'
      }
    ]
  }
]
